import { Link } from 'react-router-dom'
import './state.css'

/* The empty state (state system, 2026-09-04): one sentence that names the
 * fact, one door to where the fact changes. Replaces the four grammars
 * the pages grew (a faint note, a banner, a bare sentence, nothing) with
 * one. Empty is never loading and never an error: a page reaches this
 * only after a read came back with nothing in it. */

export interface EmptyDoor {
  label: string
  /** A route — rendered as a link. */
  to?: string
  /** Or an action on the page (open the file chooser, widen a filter). */
  onClick?: () => void
  testId?: string
}

interface Props {
  sentence: string
  door?: EmptyDoor
  testId?: string
  className?: string
  /** compact = inside a card or a drawer: less air around it. */
  compact?: boolean
}

export default function EmptyState({ sentence, door, testId, className, compact }: Props) {
  const doorTestId = door?.testId ?? 'state-empty-door'
  return (
    <div
      className={`state-empty${compact ? ' compact' : ''}${className ? ` ${className}` : ''}`}
      data-testid={testId ?? 'state-empty'}
    >
      <p className="state-sentence">{sentence}</p>
      {door ? (
        door.to ? (
          <Link className="state-door" to={door.to} data-testid={doorTestId}>
            {door.label}
          </Link>
        ) : (
          <button
            type="button"
            className="state-door"
            onClick={door.onClick}
            data-testid={doorTestId}
          >
            {door.label}
          </button>
        )
      ) : null}
    </div>
  )
}
